import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
// Vue.use(VueApexCharts);

Vue.component('VApexCharts', VueApexCharts);

export default VueApexCharts;
